import * as React from "react";
import cx from "classnames";
import styles from "./ProvisionSetupPage.module.scss";
import { v4 } from "uuid";
import { useState } from "react";
import DataTable from "../dataTable/DataTable";
import ProvisionSetupButton from "../provisionSetupButton/ProvisionSetupButton";

// icons
import SearchIcon from "@material-ui/icons/Search";
import FilterListIcon from "@material-ui/icons/FilterList";
import BasicModal from "../../basicModal/BasicModal";
import SearchBox from "./components/searchBox/SearchBox";
import FilterBox from "./components/filterBox/FilterBox";
import apis from "../../../api/apis";
import { baseRequestModel } from "../../../api/apiRequestObjects";
import { useSelector } from "react-redux";
import { IPartnerStore } from "../../../interfaces/store";
import { notifyError } from "../../../config/toastNotification";
import { APIResponseType } from "../../../config/enumApiResponseTypes";
import { ToastContainer } from "react-toastify";
import LoadingComponent from "../../loadingComponent/LoadingComponent";
import { ILocation } from "../../../interfaces/user";

//manual close button for toast notifications
const CloseButton = ({ closeToast }: any) => (
  <i
    className="material-icons"
    onClick={closeToast && window.location.reload()}
  ></i>
);

const navItems = [
  {
    orderType: "UberEats",
    orderTypeName: "Uber Eats Provision",
  },
  /*   {
    orderType: "PickMeFood",
    orderTypeName: "Pickme Food Provision",
  },
  {
    orderType: "BLXECommerce",
    orderTypeName: "BLX ECommerce Provision",
  }, */
];

const ProvisionSetupPage = (): JSX.Element => {
  const [selectedNavItem, setSelectedNavItem] = useState<any>(navItems[0]);
  const [partnerStoreList, setPartnerStoreList] = useState<IPartnerStore[]>([]);
  const [userLocationList, setUserLocationList] = useState<ILocation[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  //get redux state
  const { user } = useSelector((state: any) => state.authentication);

  // search modal
  const [searchValue, setSearchValue] = useState("");
  const [isOpenSearch, setIsOpenSearch] = useState(false);
  const toggleSearchModal = () => setIsOpenSearch(!isOpenSearch);

  // filter modal
  const [filterValue, setFilterValue] = useState("");
  const [isOpenFilter, setIsOpenFilter] = useState(false);
  const toggleFilterModal = () => setIsOpenFilter(!isOpenFilter);

  const handleGetStores = async () => {
    try {
      setIsLoading(true);
      baseRequestModel.UID.UserKey = user.UserKey;
      baseRequestModel.UID.LocationKey = user.LocationKey;
      baseRequestModel.UID.CompanyKey = user.CompanyKey;
      baseRequestModel.UID.EnvironmentName = user.EnvironmentName;
      baseRequestModel.UID.IsUrbanPiper=user.IsUrbanPiper;

      const response = await apis.Provisions.getPartnerStoreList(
        baseRequestModel
      );

      if (response.ResponseType === APIResponseType.Success) {
        setPartnerStoreList(response.ResponseData.PartnerStoreList);
        setUserLocationList(response.ResponseData.UserLocationList);
        setIsLoading(false);
      } else {
        setPartnerStoreList([]);
        setIsLoading(false);
        notifyError();
      }
    } catch (e) {
      setIsLoading(false);
    }
  };

  if (isLoading) return <LoadingComponent />;

  return (
    <div className={styles.main_wrapper}>
      <div className={styles.menu_box}>
        <div className={styles.nav_header}>
          <div className={styles.nav_items}>
            {navItems !== [] &&
              navItems.map((orderType: any) => (
                <div
                  key={v4()}
                  className={cx(
                    styles.nav_item,
                    selectedNavItem.orderType === orderType.orderType &&
                      styles.nav_item_selected
                  )}
                  onClick={() => setSelectedNavItem(orderType)}
                >
                  {orderType.orderTypeName}
                </div>
              ))}
          </div>
          <div className={styles.provision_btn_with_filter_menu}>
            <ProvisionSetupButton handleGetStores={handleGetStores} />
            <SearchIcon
              onClick={toggleSearchModal}
              className={styles.search_icon}
            />
            <FilterListIcon
              onClick={toggleFilterModal}
              className={styles.filter_icon}
            />
          </div>
        </div>
        <hr />
        <div className={styles.data_table}>
          {partnerStoreList && (
            <DataTable
              partnerStoreList={partnerStoreList}
              userLocationList={userLocationList}
            />
          )}
        </div>
      </div>
      {/* search modal */}
      <BasicModal
        isOpen={isOpenSearch}
        toggle={toggleSearchModal}
        size="md"
        closeIcon={false}
      >
        <SearchBox
          toggle={toggleSearchModal}
          searchValue={searchValue}
          setSearchValue={setSearchValue}
        />
      </BasicModal>

      {/* filter modal */}
      <BasicModal
        isOpen={isOpenFilter}
        toggle={toggleFilterModal}
        size="md"
        closeIcon={false}
      >
        <FilterBox
          toggle={toggleFilterModal}
          filterValue={filterValue}
          setFilterValue={setFilterValue}
        />
      </BasicModal>
      <ToastContainer
        className={styles.toast_notifier}
        closeButton={CloseButton}
      />
    </div>
  );
};

export default ProvisionSetupPage;
